import React from "react";

const ConfirmModal = ({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  isConfirming = false,
  onConfirm,
  onCancel,
  alertOnly = false,
}) => {
  if (!open) {
    return null;
  }

  return (
    <div
      className="confirm-modal-overlay"
      role="presentation"
      onClick={onCancel}
    >
      <div
        className="confirm-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirm-modal-header">
          <h3 id="confirm-modal-title">{title}</h3>
        </div>
        <div className="confirm-modal-body">
          <p>{message}</p>
        </div>
        <div className="confirm-modal-footer">
          {!alertOnly && (
            <button
              type="button"
              className="confirm-modal-secondary-btn"
              onClick={onCancel}
              disabled={isConfirming}
            >
              {cancelLabel}
            </button>
          )}
          <button
            type="button"
            className={
              alertOnly
                ? "confirm-modal-secondary-btn"
                : "confirm-modal-danger-btn"
            }
            onClick={alertOnly ? onCancel : onConfirm}
            disabled={isConfirming}
          >
            {isConfirming ? `${confirmLabel}…` : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
